import BurgerMenuIcon from "../assets/icons/burger";
import IfPermitted from "./IfPermitted";
import { User } from "../data/DataAccess";
import { MenuVisibilities } from "./MainBracketWrapper";
import { SURFACE, useSurface } from "../Providers/SurfaceProvider";

interface IProps {
  SetMenuVisibility: (name: string | undefined, newval: boolean) => void;
  MenuVisibilities: MenuVisibilities;
  AuthedUser: User;
  ViewAsUser: User;
  Environment: NonNullable<"LIVE" | "TEST" | "DEV" | "LOCAL" | "">;
}

export const QuickNav = (props: IProps) => {
  var burgerTimer: string | number | NodeJS.Timeout;
  const surf = useSurface();

  return (
    <div
      className="QuickJump"
      onMouseEnter={() => {
        props.SetMenuVisibility("Burger", true);
      }}
      onMouseLeave={() => {
        props.SetMenuVisibility("Burger", false);
      }}
    >
      {
        <a
          href="#"
          className="Burger"
          tabIndex={0}
          title="Service Navigation Menu"
          onClick={() => {
            props.SetMenuVisibility("Burger", !props.MenuVisibilities.Burger);
          }}
        >
          <BurgerMenuIcon />
        </a>
      }
      <div
        className={
          "QuickJumpLocations" + (props.MenuVisibilities.Burger ? " open" : "")
        }
        id="burgerM"
        aria-expanded={props.MenuVisibilities.Burger}
      >
        <ul>
          <IfPermitted Whitelist={["ESF.Reader"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.ESF ? (
                  <a
                    href={window.location.origin.toString()}
                    className="MenuItem"
                  >
                    ESF
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    ESF
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a href="https://esftest.essex.ac.uk/" className="MenuItem">
                  ESF
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a href="https://esf.essex.ac.uk/" className="MenuItem">
                  ESF
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["PGEAF.Reader"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.EAF ? (
                  <a
                    href={window.location.origin.toString() + "/PGEAF"}
                    className="MenuItem"
                  >
                    PGEAF
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    PGEAF
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a
                  href="https://eaftest.essex.ac.uk/PGEAF/"
                  className="MenuItem"
                >
                  PGEAF
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a href="https://eaf.essex.ac.uk/PGEAF/" className="MenuItem">
                  PGEAF
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["UGEAF.Reader"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.EAF ? (
                  <a
                    href={window.location.origin.toString() + "/UGEAF"}
                    className="MenuItem"
                  >
                    UGEAF
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    UGEAF
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a
                  href="https://eaftest.essex.ac.uk/UGEAF/"
                  className="MenuItem"
                >
                  UGEAF
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a href="https://eaf.essex.ac.uk/UGEAF/" className="MenuItem">
                  UGEAF
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["ECF.BasicAccess"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.ECF ? (
                  <a
                    href={window.location.origin.toString()}
                    className="MenuItem"
                  >
                    ECF
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    ECF
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a href="https://ecftest.essex.ac.uk/" className="MenuItem">
                  ECF
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a href="https://ecf.essex.ac.uk/" className="MenuItem">
                  ECF
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["AOS.Access"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.AOS ? (
                  <a
                    href={window.location.origin.toString()}
                    className="MenuItem"
                  >
                    AOS
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    AOS
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a href="https://agentstest.essex.ac.uk/" className="MenuItem">
                  AOS
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a href="https://agents.essex.ac.uk/" className="MenuItem">
                  AOS
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["Clearing.Reader"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.EAF ? (
                  <a
                    href={window.location.origin.toString() + "/Clearing"}
                    className="MenuItem"
                  >
                    Clearing
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    Clearing
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a
                  href="https://eaftest.essex.ac.uk/Clearing/"
                  className="MenuItem"
                >
                  Clearing
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a
                  href="https://eaf.essex.ac.uk/Clearing/"
                  className="MenuItem"
                >
                  Clearing
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["Compliance.View"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.ESF ? (
                  <a
                    href={window.location.origin.toString() + "/Compliance"}
                    className="MenuItem"
                  >
                    Compliance
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    Compliance
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a
                  href="https://esftest.essex.ac.uk/Compliance/"
                  className="MenuItem"
                >
                  Compliance
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a
                  href="https://esf.essex.ac.uk/Compliance/"
                  className="MenuItem"
                >
                  Compliance
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
          <IfPermitted Whitelist={["Collagen.Admins", "Admin.All"]}>
            <li>
              {props.Environment === "LOCAL" ? (
                surf.RootSurface === SURFACE.ESF ? (
                  <a
                    href={window.location.origin.toString() + "/AdminPortal"}
                    className="MenuItem"
                  >
                    Admin Portal
                  </a>
                ) : (
                  <div
                    className="MenuItem Inert Warning"
                    title="Environment switch not possible on local; change auto-environment in code."
                  >
                    Admin Portal
                  </div>
                )
              ) : (
                ""
              )}
              {props.Environment === "TEST" ? (
                <a
                  href="https://esftest.essex.ac.uk/AdminPortal/"
                  className="MenuItem"
                >
                  Admin Portal
                </a>
              ) : (
                ""
              )}
              {props.Environment === "LIVE" ? (
                <a
                  href="https://esf.essex.ac.uk/AdminPortal/"
                  className="MenuItem"
                >
                  Admin Portal
                </a>
              ) : (
                ""
              )}
            </li>
          </IfPermitted>
        </ul>
      </div>
    </div>
  );
};
